import React from 'react';
import I18n from 'i18n-js';

import { RCCheckbox } from '@reverbdotcom/cadence/components';

import { ActionType } from './bulkSelectReducer';
import BulkSelectContext from './BulkSelectContext';
import { isValidForBulkSelect } from './toolbarHelpers';

export default function SellerListingCardsToolbar() {
  const {
    bulkSelectState,
    dispatch,
  } = React.useContext(BulkSelectContext);

  const { selectableListings, selectedListings } = bulkSelectState;

  const hasSelectableListings = !!selectableListings.length;

  const isAllSelected = hasSelectableListings && selectableListings.length == selectedListings.length;

  const isSomeSelected = !!selectedListings.length && !isAllSelected;

  const I18nSelectKey = (isAllSelected || isSomeSelected) ? 'selectedListings' : 'selectListings';

  function updateSelections() {
    if (selectableListings.length == selectedListings.length) {
      dispatch({
        type: ActionType.DESELECT_ALL_LISTINGS,
      });
    } else {
      dispatch({
        type: ActionType.SELECT_ALL_LISTINGS,
      });
    }
  }

  function checkedState() {
    if (isAllSelected) return true;
    if (isSomeSelected) return 'mixed';

    return false;
  }

  if (!isValidForBulkSelect(window)) return null;

  return (
    <div className="d-flex fx-align-center gap-3 plr-4 pb-4">
      <RCCheckbox
        disabled={!hasSelectableListings}
        checked={checkedState()}
        triState={isSomeSelected}
        label={
          <div className="weight-bold">
            {I18n.t(`discovery.listingsManagement.sellerListingCard.toolbar.${I18nSelectKey}`, {
              count: selectedListings.length,
            })}
          </div>
        }
        onChange={() => updateSelections()}
      />
    </div>
  );
}
